import type { Units, Value } from './runesTypes';

export const MM_PER_INCH = 25.4;

/**
 * Interpret `value.simplifiedValue` as a length in `preferredUnits ?? fallbackUnits`
 * and return millimeters (in → mm). Non-length units (e.g. deg) return the raw number.
 */
export const convertValueToMillimeters = (
  value: Value,
  fallbackUnits: Units,
): number => {
  const { simplifiedValue } = value;
  const units = simplifiedValue.preferredUnits ?? fallbackUnits;
  const numericValue = simplifiedValue.value;

  switch (units) {
    case 'mm':
      return numericValue;
    case 'in':
      return numericValue * MM_PER_INCH;
    default:
      return numericValue;
  }
};

export const convertValueToInches = (
  value: Value,
  fallbackUnits: Units,
): number => {
  const { simplifiedValue } = value;
  const units = simplifiedValue.preferredUnits ?? fallbackUnits;
  const numericValue = simplifiedValue.value;

  switch (units) {
    case 'in':
      return numericValue;
    case 'mm':
      return numericValue / MM_PER_INCH;
    default:
      return numericValue;
  }
};
